/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-12-24 08:56:11
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-01-16 10:58:56
 * @FilePath: /wemeet-web-activity/src/pages/questions/components/radio/index.ts
 * @Description: 表单单选项
 */
import React, { memo } from 'react';
import { Radio } from '@tencent/tea-component';
const RadioInput = ({
  value,
  options,
  onChange
}) => {
  if (!(options && options.length > 0)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Radio.Group, {
    value: value,
    onChange: onChange,
    layout: "column"
  }, options?.map((item, index) => {
    if (typeof item === 'string') {
      return /*#__PURE__*/React.createElement(Radio, {
        className: "event-questions-form-check",
        key: item,
        name: index.toString()
      }, item);
    }
    return /*#__PURE__*/React.createElement(Radio, {
      className: "event-questions-form-check",
      key: item.name,
      name: item.name
    }, item.txt);
  }));
};
export default /*#__PURE__*/memo(RadioInput);